import { Button, Typography } from "@mui/material";
import React from "react";

function VoiceCloningIntroduction({ onNext }) {
    return (
        <div style={{ padding: "10px" }}>
            <Typography variant="highlightSemibold">Clone New Sound</Typography>
            <br />
            <Typography variant="supportRegular">
                New cloning sound and generating different speeches is so easy
                and fun. Please go through the steps given below.
            </Typography>
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 1 - Upload Sound
            </Typography>
            <br />
            <Typography variant="captionEmphasis">
                You will be asked to upload upto 30 sample sounds (max 100mb
                each) so that our sound cloning tool will clone that sound to
                generate different speeches. So keep them ready when processing.
                Please provide clean & clear sound for better and realistic
                results. Click Here to know more about the sound guidelines.
            </Typography>{" "}
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 2 - Sound Cloning
            </Typography>{" "}
            <br />
            <Typography variant="captionEmphasis">
                Once you upload sound & click on continue then our system will
                start cloning your sound. This can take up to 20 minutes to
                complete. Please wait until our system finishes cloning sound or
                you can leave the page and cloning will continue in background.
                We will notify you once cloning is done.
            </Typography>{" "}
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 3 - Generate Speeches
            </Typography>{" "}
            <br />
            <Typography variant="captionEmphasis">
                Once cloning is done you will be taken to input text prompt
                section. where you can ask system to generate situation based
                sound speeches. i. e. “Lorem ipsum dolor sit amet is a
                placeholder text used in design”{" "}
            </Typography>{" "}
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 4 - Boom! Enjoy Cloned Sound
            </Typography>{" "}
            <br />
            <Typography variant="captionEmphasis">
                Yay!!! enjoy cloned sound. You can download the speeches
                generated. You can generate up to 10 speeches per day.
            </Typography>{" "}
            <br /> <br />
            {/* Your introduction content here */}
            <Button
                variant="contained"
                sx={{ width: "25%", marginTop: "3rem", marginBottom: "2rem" }}
                onClick={onNext}
            >
                Continue
            </Button>
        </div>
    );
}
export default VoiceCloningIntroduction;
